<script>
  import { onMount } from "svelte";

  onMount(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.deftform.com/embed.js";
    script.async = true;

    // Append the script to the container holding the form div
    const container = document.querySelector(".deftform").parentElement;
    container.appendChild(script);

    return () => {
      container.removeChild(script);
    };
  });
</script>

<div id="contact_form" class="section">
  <div class="container">
    <div class="row form-row">
      <h3 fade class="blue-grey-text text-lighten-2">Connect</h3>

      <div class="row">
        <div class="col s12">
          <div class="blue-grey-text text-darken-2 center-align">
            <i class="material-icons prefix center-align">
              <a
                href="https://www.instagram.com/lfcamacho_"
                title="https://www.instagram.com/lfcamacho_"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/media/icons/material-icons/full_instagram_24dp.png"
                  alt="full instagram icon - LFCamacho"
                /></a
              ></i
            >
          </div>
        </div>
      </div>
      <div class="col s12">
        <div class="blue-grey-text text-darken-2 center-align">
          <div class="separator">
            <span>or</span>
          </div>
        </div>
      </div>

      <div class="col s12">
        <div style="width:100%; min-height:350px">
          <div
            class="deftform"
            data-form-id="1cde7dc5-e8d7-403f-9fcb-13e849aa54fb"
            data-form-width="100%"
            data-form-align="center"
            data-form-auto-height="1"
          ></div>
          <!-- <script src="https://cdn.deftform.com/embed.js"></script> -->
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  #contact_form .container {
    min-height: 350px;
  }
  .form-row {
    width: 100%;
  }
  #contact_form {
    background-color: #f5f3f2;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 20px 0; /* spacing around separator */
  }

  .separator::before,
  .separator::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #ccc;
  }

  .separator:not(:empty)::before {
    margin-right: 10px;
  }

  .separator:not(:empty)::after {
    margin-left: 10px;
  }

  .separator span {
    color: #666;
    font-weight: bold;
  }
</style>
